<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 px-3 pt-3>
            <div class="title">
              Encuestas UG | Bandeja de Encuestas
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="mt-3 px-6">
        <div v-if="loading">
          <v-layout wrap>
              <v-flex
                  key="sk_table_encuestas"
                  xs12
                  text-sm-right
                  px-3
                  py-3
              >
                  <v-skeleton-loader 
                      type="table" />
              </v-flex>
          </v-layout>
        </div>
        <data-table-encuestas v-else-if="valido && !loading"></data-table-encuestas>
        <!-- <v-row v-else-if="valido && !loading">
          <v-col 
            cols="12"
          >
            <v-alert 
              type="success">
              Inicio Bandeja Encuestas
            </v-alert>
          </v-col>
        </v-row> -->
        <v-alert 
            v-else 
            type="error">
            Usted no cuenta con el permiso para acceder a esta página.
        </v-alert>
      </v-card-text>
    </v-card>

    <v-snackbar
        key="snackbar_bandejaencuestas"
        v-model="snackbarError"
        :bottom="true"
        :multi-line="true"
        color="error"
    >
      {{ textoError }}
      <v-btn 
        dark 
        text 
        @click="snackbarError = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "BandejaEncuestas",
  components: {
    DataTableEncuestas: () =>
      import("../components/bandejaEncuestas/DataTableEncuestas"),
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true,
      snackbarError: false,
      textoError: "",
    };
  },
  computed: {
    ...mapState(["perfil", "encuestasRoles"]),
    ...mapGetters("oidc", ["oidcUser"]),
  },
  beforeMount () {},
  async mounted () {
    this.validarAcceso();
  },
  methods: {
    ...mapActions(['tienePermisoServicio']),
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      self.snackbarError = false;
      self.textoError = "";
      
      if(await self.tienePermisoServicio({permiso: 'Administrador Encuestas'}) == true ||
         await self.tienePermisoServicio({permiso: 'Coordinador'}) == true ||
         self.encuestasRoles.length > 0
      ){
        self.valido = true;
        self.loading = false;
      } else {
        self.loading = false;
        self.valido = true;
      }

    }
  }
};
</script>

<style>
.card-ug {
  border: 1px solid #b5a36a !important;
}

.azul-ug {
  color: #0e345b !important;
}
</style>
